import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styled, { css } from 'styled-components';
import { formatHours } from '../../utilities/timeUtility';
import { formatAvailabilityMessage } from '../../utilities/helperUtility';

const StyledInput = styled.input`
  ${({ styled }) => {
  if (!styled) return '';
  
  const bgc = styled.body.color,
        fs = styled.body.fontSize;
  
  return css`
      && {
        display: none;
        + label {
          color: ${bgc};
          font-weight: bold;
          font-size: 1rem;
          cursor: pointer;
          user-select: none;
          margin-left: 5px;
          padding-left: 10px;
          padding-right: 10px;
          position: relative;

          &::before {
            transition: all 250ms cubic-bezier(0.4, 0.25, 0.3, 1);
            content: '';
            width: ${fs};
            height: ${fs};
            border-radius: 50%;
            border: 1px solid ${bgc};
            font-size: 0;
            position: absolute;
            bottom: 50%;
            left: 50%;
            transform: translate(-50%, 50%);
          }

          &::after {
            transition: all 250ms cubic-bezier(0.4, 0.25, 0.3, 1);
            content: '';
            width: 0;
            height: 0;
            border-radius: 50%;
            background-color: ${bgc};
            position: absolute;
            bottom: 50%;
            left: 50%;
            transform: translate(-50%, 50%);
          }
        }
        &:checked + label {
          &::before {
            background-color: transparent;
            width: ${fs};
            height: ${fs};
            border-width: 1px;
          }

          &::after {
            width: calc(${fs} * 0.5);
            height: calc(${fs} * 0.5);
          }
        }
      }
    `;
  }};
`;

export default class TimeSlot extends Component {
  render() {
    const {
      style,
      disabled,
      onClick,
      locale,
      timeZone,
      timeslot: { id, start, finish },
      isDisplayRange,
      isShowRemainingSpace,
      selectedTimeSlot,
      availableSpace,
      timeFormat,
      quantity,
      translation
    } = this.props;

    return (
      <div
        className="pointer flexbox space-between"
        key={id}
        style={{ padding: '5px' }}
        onClick={!disabled ? onClick : () => {}}
      >
        <StyledInput
          readOnly
          type="radio"
          className="radio"
          styled={style}
          value={start}
          disabled={disabled}
          checked={selectedTimeSlot ? selectedTimeSlot.id == id : false}
        />
        <label />
        <span className="flexbox vertical-center" style={{ marginRight: 'auto', marginLeft: '10px' }}>
          {formatHours(moment(start), locale, timeZone, timeFormat)}
          {isDisplayRange && ` - ${formatHours(moment(finish), locale, timeZone, timeFormat)}`}
          {isShowRemainingSpace && ` / ${formatAvailabilityMessage(availableSpace, quantity, translation)} `}
        </span>
      </div>
    );
  }
}

TimeSlot.propTypes = {
  style: PropTypes.any,
  disabled: PropTypes.bool,
  className: PropTypes.any,
  onClick: PropTypes.func.isRequired,
  timeZone: PropTypes.string,
  locale: PropTypes.string,
  start: PropTypes.string,
  finish: PropTypes.string,
  isDisplayRange: PropTypes.bool,
  isShowRemainingSpace: PropTypes.bool,
  timeFormat: PropTypes.string,
  availableSpace: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
